import { LoginInput } from '@/features/auth/validation/login-input.schema';
import { supabase } from '@/lib/supabase/config';

export const login = async (input: LoginInput) => {
  const { data, error } = await supabase.auth.signInWithPassword(input);
  if (error) {
    throw error;
  }
  return data;
};
